import { Tooltip } from 'antd';
import STTypo from 'core/shared/typo';
import type { ReactNode } from 'react';
import type { To } from 'react-router-dom';
import { Link, useMatch, useResolvedPath } from 'react-router-dom';

type MenuItemProps = {
  to: To;
  title: string | ReactNode;
  icon: ReactNode;
  label: string;
  testId: string;
  end?: boolean;
  target?: string;
  rel?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  isSelected?: boolean;
  showTooltip?: boolean;
};

export const MenuItem = ({
  to,
  title,
  icon,
  label,
  testId,
  end = false,
  target,
  rel,
  onClick,
  isSelected,
  showTooltip = true
}: MenuItemProps) => {
  const resolvedPath = useResolvedPath(to);
  const routeMatch = useMatch({ path: resolvedPath.pathname, end });
  const isActive = isSelected ?? Boolean(routeMatch);
  const content = (
    <div>
      <div className='st-menu-active' />
      {icon}
      <STTypo>{label}</STTypo>
    </div>
  );

  return (
    <Link
      data-testid={testId}
      aria-current={isActive ? 'page' : undefined}
      className={`st-menu-item ${isActive ? 'st-menu-item--selected' : ''}`}
      to={to}
      target={target}
      rel={rel}
      onClick={onClick}>
      {showTooltip ? (
        <Tooltip title={title} placement='right'>
          {content}
        </Tooltip>
      ) : (
        content
      )}
    </Link>
  );
};
